<template>
    <div class="container" :class="{'kk_lang': i18n().locale === 'kk'}">
      <cashback-modal v-if="showModal" @toggleModal="toggleModal"/>
      <div class="banner">
        <div class="banner-info">
          <h1 v-html="$t('banner.title')"></h1>
          <p>{{ $t('banner.subtitle') }}</p>
          <div class="banner-info__bottom">
            <div class="banner-info__btn mobile-hide" @click="scrollToElement('cashback')">
              <img src="../assets/images/icons/coin-icon.png" alt="coin">
              <span>{{ $t('banner.btn') }}</span>
            </div>
            <img src="@/assets/images/partners.png" alt="partners" class="banner-info__partners">
          </div>
        </div>
        <div class="banner-mobile__btn mobile-show" @click="scrollToElement('cashback')">
          <img src="../assets/images/icons/coin-icon.png" alt="coin">
          <span>{{ $t('banner.btn') }}</span>
        </div>
      </div>

      <div class="advantages">
        <div class="advantages-item">
          <img src="../assets/images/icons/percentage-icon.png" alt="percentage">
          <span>{{ $t('advantages.cashback') }}</span>
        </div>
        <div class="advantages-item">
          <img src="../assets/images/icons/star-icon.png" alt="star">
          <span>{{ $t('advantages.offers') }}</span>
        </div>
        <div class="advantages-item">
          <img src="../assets/images/icons/trend-up-icon.png" alt="trend-up">
          <span>{{ $t('advantages.market-returns') }}</span>
        </div>
      </div>

      <div class="cashback" id="cashback">
        <div class="cashback-inner">
          <div class="cashback-content">
            <h3 v-html="$t('cashback.title')"></h3>
            <div class="cashback-content__text">{{ $t('cashback.text') }}</div>
            <div class="cashback-content__btns">
              <a target="_blank" href="https://loyalty.bankffin.kz/ru" class="cashback-content__btn">
                <p>{{ $t('cashback.btn') }}</p>
                <img src="@/assets/images/icons/arrow-white-icon.svg" alt="">
              </a>
              <div class="cashback-content__notice-border">
                <div class="cashback-content__notice">
                  <p>*</p>
                  <p>{{ $t('cashback.notice') }}</p>
                </div>
              </div>
            </div>
          </div>
          <img class="cashback-img__desktop" src="../assets/images/cashback.png" alt="cashback">
        </div>
      </div>

      <div class="about">
        <h2>{{ $t('about.title') }}</h2>
        <currency-activation-tabs
            :tabs="aboutData.aboutTabs"
            :active-tab="activeAboutTab"
            @activeTab="setActiveAboutTab($event)"
        >
          <template #tabs-content>
            <div v-if="activeAboutTab === 2" class="about__content">
              <div class="about-top">
                <div class="about-top-left">
                  <h4>
                    <span v-html="$t('about.currency')"></span>
                    <a href="https://www.nasdaq.com/market-activity/stocks/frhc" target="_blank">
                      <span>NASDAQ:FRHC</span>
                      <img src="../assets/images/icons/link-icon.svg" alt="link">
                    </a>
                  </h4>
                  <p>{{ $t('about.stocks') }}</p>
                  <div class="about-top-left__stock">
                    <div class="about-top-left__stock-item">
                      <div class="about-top-left__stock-item-img">
                        <img src="../assets/images/icons/frhc-icon.png" alt="frhc">
                      </div>
                      <span>FRHC</span>
                    </div>
                    <div class="about-top-left__stock-item">
                      <div class="about-top-left__stock-item-img">
                        <img src="../assets/images/icons/aapl-icon.png" alt="aapl">
                      </div>
                      <span>AAPL</span>
                    </div>
                    <div class="about-top-left__stock-item">
                      <div class="about-top-left__stock-item-img">
                        <img src="../assets/images/icons/tsla-icon.png" alt="tsla">
                      </div>
                      <span>TSLA</span>
                    </div>
                    <div class="about-top-left__stock-item">
                      <div class="about-top-left__stock-item-img">
                        <img src="../assets/images/icons/msft-icon.png" alt="msft">
                      </div>
                      <span>MSFT</span>
                    </div>
                  </div>
                </div>

                <div class="about-top-right">
                  <div class="about-top-right__header">
                    <p class="mobile-hide" v-html="$t('about.stock-up')"></p>
                    <p class="mobile-show" v-html="$t('about.stock-up-mobile')"></p>
                    <div
                        v-if="isDesktop"
                        ref="aboutInfoBlock"
                        :data-text="$t('about.hint')"
                        @mouseover="aboutInfo = true"
                        @mouseout="aboutInfo = false"
                        :class="{hovering: aboutInfo}"
                    >
                      <img src="../assets/images/icons/info-icon.png" alt="info">
                    </div>
                    <div
                        v-else
                        ref="aboutInfoBlock"
                        :data-text="$t('about.hint')"
                        @click="toggleAboutBlock"
                        :class="{hovering: aboutInfo}"
                    >
                      <img src="../assets/images/icons/info-icon.png" alt="info">
                    </div>
                  </div>
                  <div class="about-top-right__comment">
                    <p>{{ $t('about.comment') }}</p>
                  </div>
                </div>
              </div>
              <div class="about-bottom">
                <div class="about-bottom-left">
                  <img src="../assets/images/icons/bold-info-icon.png" alt="bold info">
                  <p v-html="$t('about.info-1')"></p>
                </div>
              </div>
            </div>
            <div v-else class="about__content">
              <div class="about__content-top">
                <div class="about__content-block">
                  <p
                      class="about__content-title"
                      v-html="$t('about.tabs-content.title-1')"
                  />
                </div>
                <div class="about__content-block">
                  <div class="about__content-block-top">
                    <p class="about__content-block-top-title">{{ $t('about.tabs-content.title-2') }}</p>
                    <div class="about__content-block-top-nav">
                      <svg class="about__content-block-top-nav-prev" :class="{active: companiesScrolled}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="scrollCompanies(false)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0438 20.7905C16.2824 20.6315 16.4402 20.3949 16.4823 20.1326C16.5245 19.8703 16.4477 19.6039 16.2687 19.392L9.97071 12L16.2687 4.60801C16.4477 4.39606 16.5245 4.12965 16.4823 3.86738C16.4402 3.60512 16.2824 3.36848 16.0438 3.20952C15.925 3.12768 15.7889 3.06784 15.6436 3.03353C15.4983 2.99922 15.3467 2.99114 15.1978 3.00976C15.0489 3.02839 14.9057 3.07334 14.7767 3.14197C14.6477 3.21059 14.5355 3.3015 14.4468 3.4093L7.7889 11.2208C7.59735 11.445 7.49365 11.7186 7.49365 12C7.49365 12.2814 7.59735 12.555 7.7889 12.7792L14.4468 20.5907C14.5355 20.6985 14.6477 20.7894 14.7767 20.858C14.9057 20.9267 15.0489 20.9716 15.1978 20.9902C15.3467 21.0089 15.4983 21.0008 15.6436 20.9665C15.7889 20.9322 15.925 20.8723 16.0438 20.7905Z" fill="#636366"/>
                      </svg>

                      <svg class="about__content-block-top-nav-next" :class="{active: !companiesScrolled}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="scrollCompanies(true)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.95621 20.7905C7.71759 20.6315 7.55984 20.3949 7.51766 20.1326C7.47547 19.8703 7.55232 19.6039 7.73128 19.392L14.0293 12L7.73128 4.60801C7.55232 4.39606 7.47547 4.12965 7.51765 3.86738C7.55984 3.60512 7.71759 3.36848 7.95621 3.20952C8.07503 3.12768 8.21112 3.06784 8.35644 3.03353C8.50175 2.99922 8.65333 2.99114 8.80222 3.00976C8.95111 3.02839 9.09429 3.07334 9.22328 3.14197C9.35227 3.21059 9.46445 3.3015 9.5532 3.4093L16.2111 11.2208C16.4027 11.445 16.5063 11.7186 16.5063 12C16.5063 12.2814 16.4027 12.555 16.2111 12.7792L9.5532 20.5907C9.46445 20.6985 9.35227 20.7894 9.22328 20.858C9.09429 20.9267 8.95111 20.9716 8.80222 20.9902C8.65333 21.0089 8.50175 21.0008 8.35644 20.9665C8.21112 20.9322 8.07503 20.8723 7.95621 20.7905Z" fill="#F2F2F7"/>
                      </svg>
                    </div>
                  </div>
                  <div class="about__content-block-bottom">
                    <div class="about__content-block-bottom-img" :class="{scrolled: companiesScrolled}">
                      <img src="@/assets/images/companies.png" alt="companies">
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__content-bottom">
                <div
                    :class="`about__content-box about__content-box-${idx + 1}`"
                    v-for="(block, idx) in aboutData.aboutContentBlocks"
                    :key="idx"
                >
                  <div class="about__content-box__title">{{ $t(block.title) }}</div>
                  <div class="about__content-box__text">{{ $t( block.text) }}</div>
                </div>
              </div>
              <div class="about__content-bottom-notice">
                {{ $t('about.notice') }}
              </div>
              <div class="about__content-bottom-notice__mobile" v-html="$t('about.notice-mobile')"></div>
            </div>
          </template>
        </currency-activation-tabs>
      </div>

<!--      <div class="proposition" id="proposition">
        <h2 class="mobile-hide">{{ $t('proposition.title') }}</h2>
        <div class="proposition-block">
          <h3 v-html="$t('proposition.subtitle')"></h3>
          <p @click="toggleModal(true)" class="proposition-block-link">{{ $t('proposition.link') }}</p>
          <div class="proposition-block-mobile-img">
            <img class="mobile-show" src="../assets/images/proposition-bg-mobile.png" alt="proposition">
          </div>
          <div class="proposition-block-text">
            <p>{{ $t('proposition.buy') }}</p>
          </div>
          <div class="proposition-block-percentage">
            <div class="proposition-block-percentage-items">
              <div class="proposition-block-percentage-subitem">
                <h4>{{ $t('proposition.p1.cashback') }}</h4>
                <span v-html="$t('proposition.p1.text')"></span>
              </div>
              <div class="proposition-block-percentage-subitem">
                <h4>{{ $t('proposition.p3.cashback') }}</h4>
                <span v-html="$t('proposition.p3.text')"></span>
              </div>
            </div>
            <div class="proposition-block-percentage-item">
              <h4>{{ $t('proposition.p2.cashback') }}</h4>
              <span v-html="$t('proposition.p2.text')"></span>
            </div>
          </div>
        </div>
      </div>-->

      <div class="new-currency">
        <h2>{{ $t('new-currency.title') }}</h2>
        <div class="new-currency-block">
          <div class="new-currency-block__left">
            <h4>{{ $t('new-currency.left.title') }}</h4>
            <p>{{ $t('new-currency.left.subtitle') }}</p>
            <div class="new-currency-block__left-info">
              {{ $t('new-currency.left.comment') }}
            </div>
          </div>
          <div class="new-currency-block__right">
            <div class="new-currency-block__right-top">
              <h5>{{ $t('new-currency.right.title') }}</h5>
              <p>1 000 000,<span>00 ₸</span></p>
            </div>
            <div class="new-currency-block__right-bottom">
              <div class="new-currency-block__right-bottom__currency">
                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/kzt.png" alt="kzt">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>207 870 ₸</div>
                    <span>{{ $t('new-currency.right.kzt') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/usd.png" alt="usd">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>180 $</div>
                    <span>{{ $t('new-currency.right.usd') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/cny.png" alt="cny">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>1 000 ¥</div>
                    <span>{{ $t('new-currency.right.cny') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/euro.png" alt="euro">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>500 €</div>
                    <span>{{ $t('new-currency.right.euro') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/rub.png" alt="rub">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>19 800 ₽</div>
                    <span>{{ $t('new-currency.right.rub') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/try.png" alt="try">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>10 145 ₺</div>
                    <span>{{ $t('new-currency.right.try') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/aed.png" alt="aed">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>982 Dh</div>
                    <span>{{ $t('new-currency.right.aed') }}</span>
                  </div>
                </div>

                <div class="new-currency-block__right-bottom__currency-item">
                  <img src="../assets/images/currency/frhc.png" alt="frhc">
                  <div class="new-currency-block__right-bottom__currency-item-info">
                    <div>
                      10 000
                      <img src="../assets/images/icons/freedom-icon.svg" alt="freedom icon">
                    </div>
                    <span>{{ $t('new-currency.right.frhc') }}</span>
                  </div>
                </div>
              </div>
              <div class="new-currency-block__right-bottom__info">
                <img src="../assets/images/icons/info-icon.png" alt="info">
                <p>{{ $t('new-currency.right.info') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="new-currency-bottom">
          <div class="new-currency-bottom-left">
            <img src="../assets/images/icons/fhrc-coin.png" alt="frhc coin">
            <p v-html="$t('new-currency.info-1')"></p>
          </div>
          <div class="new-currency-bottom-right">
            <img src="../assets/images/icons/double-circle.png" alt="double circle">
            <p v-html="$t('new-currency.info-2')"></p>
          </div>
        </div>
      </div>

      <div class="deposit-card">
        <h4 v-html="$t('deposit-card.title')"></h4>
        <p>{{ $t('deposit-card.subtitle') }}</p>
        <a href="https://bankffin.kz/ru/card-issuance/deposit-card" target="_blank">{{ $t('deposit-card.btn') }}</a>
        <div class="deposit-card-btns">
          <a :href="'https://bankffin.kz/'+i18n().locale+'/res/mobile-app'" target="_blank" class="deposit-card-btns__appstore">
            <img src="../assets/images/icons/app-store-icon.png" alt="appstore">
            <span>App Store</span>
          </a>
          <a :href="'https://bankffin.kz/'+ i18n().locale +'/res/mobile-app'" target="_blank" class="deposit-card-btns__playmarket">
            <img src="../assets/images/icons/google-play-icon.png" alt="google play">
            <span>Play Market</span>
          </a>
        </div>
      </div>

      <div class="frhc-advantages">
        <h2>{{ $t('frhc-advantages.title') }}</h2>
        <div class="frhc-advantages__grid">
          <div class="frhc-advantages__grid-item">
            <div class="frhc-advantages__grid-item-wrapper">
              <div class="frhc-advantages__grid-item-video">
                <img src="@/assets/images/video-preview/1.png" alt="">
              </div>
              <div class="frhc-advantages__grid-item-info">
                <h4 v-html="$t('frhc-advantages.grid1.title')"></h4>
                <p>{{ $t('frhc-advantages.grid1.p1') }}</p>
                <p>
                  <span>{{ $t('frhc-advantages.grid1.p2') }}</span>
                  <a><img src="../assets/images/icons/redirect-icon.png" alt="redirect"></a>
                </p>
              </div>
            </div>
          </div>
          <div class="frhc-advantages__grid-item">
            <div class="frhc-advantages__grid-item-wrapper">
              <div class="frhc-advantages__grid-item-video">
                <img src="@/assets/images/video-preview/2.png" alt="">
              </div>
              <div class="frhc-advantages__grid-item-info">
                <h4>{{ $t('frhc-advantages.grid2.title') }}</h4>
                <p>
                  <img src="../assets/images/icons/logo-icon.png" alt="logo">
                  <span>{{ $t('frhc-advantages.grid2.p1') }}</span>
                </p>
                <div class="frhc-advantages__grid-item-info-faq">
                  <div class="frhc-advantages__grid-item-info-faq-item">
                    {{ $t('frhc-advantages.grid2.faq.p1') }}
                  </div>
                  <div class="frhc-advantages__grid-item-info-faq-item">
                    {{ $t('frhc-advantages.grid2.faq.p2') }}
                  </div>
                  <div class="frhc-advantages__grid-item-info-faq-item">
                    {{ $t('frhc-advantages.grid2.faq.p3') }}
                  </div>
                  <div class="frhc-advantages__grid-item-info-faq-item">
                    {{ $t('frhc-advantages.grid2.faq.p4') }}
                  </div>
                  <div class="frhc-advantages__grid-item-info-faq-item">
                    {{ $t('frhc-advantages.grid2.faq.p5') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="frhc-advantages__grid-item">
            <div class="frhc-advantages__grid-item-wrapper">
              <div class="frhc-advantages__grid-item-video">
                <img src="@/assets/images/video-preview/3.png" alt="">
              </div>
              <div class="frhc-advantages__grid-item-info">
                <h4>{{ $t('frhc-advantages.grid3.title') }}</h4>
                <p>{{ $t('frhc-advantages.grid3.p1') }}</p>
                <p>{{ $t('frhc-advantages.grid3.p2') }}</p>
              </div>
            </div>
          </div>
          <div class="frhc-advantages__grid-item">
            <div class="frhc-advantages__grid-item-wrapper">
              <div class="frhc-advantages__grid-item-video">
                <img src="@/assets/images/video-preview/4.png" alt="">
              </div>
              <div class="frhc-advantages__grid-item-info">
                <h4>{{ $t('frhc-advantages.grid4.title') }}</h4>
                <p>{{ $t('frhc-advantages.grid4.p1') }}</p>
                <p>{{ $t('frhc-advantages.grid4.p2') }}</p>
                <a href="https://bankffin.kz/ru/card-issuance/deposit-card" target="_blank">
                  <span>{{ $t('frhc-advantages.grid4.btn') }}</span>
                  <img src="../assets/images/icons/arrow.svg" alt="arrow">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <currency-activation />

      <div class="market">
        <h4 v-html="$t('market.title')"></h4>
        <p>{{ $t('market.subtitle') }}</p>
        <div class="market-btns">
          <a :href="'https://bankffin.kz/'+i18n().locale+'/res/mobile-app'" target="_blank" class="market-btns__appstore">
            <img src="../assets/images/icons/app-store-icon.png" alt="appstore">
            <span>App Store</span>
          </a>
          <a :href="'https://bankffin.kz/'+i18n().locale+'/res/mobile-app'" target="_blank" class="market-btns__playmarket">
            <img src="../assets/images/icons/google-play-icon.png" alt="google play">
            <span>Play Market</span>
          </a>
        </div>
      </div>

      <div class="faq">
        <h2>{{ $t('faq.title') }}</h2>
        <div class="faq-list">
          <faq-item
              :header="$t('faq.item1.header')"
              :content="$t('faq.item1.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item2.header')"
              :content="$t('faq.item2.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item3.header')"
              :content="$t('faq.item3.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item4.header')"
              :content="$t('faq.item4.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item5.header')"
              :content="$t('faq.item5.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item6.header')"
              :content="$t('faq.item6.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item8.header')"
              :content="$t('faq.item8.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item9.header')"
              :content="$t('faq.item9.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item10.header')"
              :content="$t('faq.item10.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item11.header')"
              :content="$t('faq.item11.content')">
          </faq-item>
          <faq-item
              :header="$t('faq.item14.header')"
              :content="$t('faq.item14.content')">
          </faq-item>
        </div>
      </div>
    </div>
</template>

<script>
import i18n from '@/i18n'
import FaqItem from "@/components/FaqItem.vue";
import CurrencyActivation from "@/components/CurrencyActivation.vue";
import CurrencyActivationTabs from "@/components/CurrencyActivationTabs.vue";
import aboutData from "@/jsons/aboutData.js";
import CashbackModal from "@/components/CashbackModal.vue";

export default {
  name: "HomeView",
  data() {
    return {
      aboutData,
      isIOSorMacOS: /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
      propositionInfo: false,
      aboutInfo: false,
      isDesktop: true,
      activeAboutTab: null,
      showModal: false,
      companiesScrolled: false,
    }
  },
  mounted() {
    this.activeAboutTab = aboutData.aboutTabs[0]?.id;
    this.detectDevice();
    window.addEventListener("resize", this.detectDevice)
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("scroll", this.fixTabsOnScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.detectDevice);
    document.removeEventListener("click", this.handleClickOutside);
    window.addEventListener("scroll", this.fixTabsOnScroll);
  },
  components: {
    CashbackModal,
    CurrencyActivationTabs,
    CurrencyActivation,
    FaqItem,
  },
  methods: {
    i18n() {
      return i18n
    },
    scrollCompanies(scroll) {
      this.companiesScrolled = scroll
    },
    scrollToElement(element) {
      this.$scrollTo('#' + element, 500, { offset: -100 })
    },
    handleClickOutside(event) {
      if (this.$refs.propositionInfoBlock && !this.$refs.propositionInfoBlock.contains(event.target)) {
        this.propositionInfo = false;
      }

      if (this.$refs.aboutInfoBlock && !this.$refs.aboutInfoBlock.contains(event.target)) {
        this.aboutInfo = false;
      }
    },
    detectDevice() {
      // Update isDesktop based on screen width
      this.isDesktop = window.innerWidth > 768; // Adjust this threshold as needed
    },
    toggleAboutBlock() {
      this.aboutInfo = !this.aboutInfo
    },
    togglePropositionBlock() {
      this.propositionInfo = !this.propositionInfo
    },
    setActiveAboutTab(tabId) {
      this.activeAboutTab = tabId;
    },
    fixTabsOnScroll() {
      if (!this.isDesktop) {
        let fixedBlock = document.querySelector(".about .tabs .tabs__list-wrapper");
        let aboutTitle = document.querySelector(".about > h2");
        let aboutContent = document.querySelector(".about__content");

        if (window.pageYOffset >= aboutTitle.offsetTop + (aboutTitle.offsetHeight / 2.3)
            && window.pageYOffset <= aboutTitle.offsetTop + (aboutContent.offsetHeight)) {
          fixedBlock.style.position = "fixed";
          fixedBlock.style.top = "4rem";
          fixedBlock.style.width = "100%";
          aboutContent.style.marginTop = "6.125rem"
          fixedBlock.style.left = "0";
          fixedBlock.style.backgroundColor = "#1A1A1A";
        } else {
          fixedBlock.style.position = "relative";
          fixedBlock.style.top = "0";
          aboutContent.style.marginTop = "2rem"
          fixedBlock.style.width = "calc(100% + 2rem)";
          fixedBlock.style.left = "-1rem";
          fixedBlock.style.backgroundColor = "transparent";
        }
      }
    },
    toggleModal(data) {
      this.showModal = data;
    }
  }
}

</script>
